import React, { useContext, useState } from "react";

import { Grid, makeStyles, Paper } from "@material-ui/core";
import {
  InputCheckboxMaster,
  InputReactDatepicker,
  InputTextArea,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { FORM_RESET_DETAIL, status_barang } from "../../helpers";
import {
  DEFAULT_BOX_SHADOW,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  PRIMARY_BACKGROUND,
} from "App/constants";
import Title from "App/Component/ui/title/Title";
import { SearchIcon } from "App/Assets";
import InputOptionMaster from "App/Component/ui/input/InputOptionMaster/InputOptionMaster";
import ModalFixedAsset from "./ModalFixedAsset";
import moment from "moment";
export default function FormDetail({ setNewDataReqList }) {
  const {
    formData,
    formDetail,
    setFormDetail,
    listDetailWork,
    setListDetailWork,
  } = useContext(FormContext);
  const [showModalFA, setShowModalFA] = useState(null);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const useStyles = makeStyles({
    root: {
      width: "auto",
    },
    paper: {
      width: "100%",
      margin: "0",
      padding: "1rem 1.5rem",
      backgroundColor: PRIMARY_BACKGROUND,
      boxShadow: DEFAULT_BOX_SHADOW,
    },
    table: {
      width: "100%",
      margin: "0 auto",
      overflow: "auto",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    textRed: {
      color: "red",
    },
    border: {
      paddingTop: "10px",
      borderBottom: "1.5px dashed #333333",
    },
  });
  const classes = useStyles();
  const handleClickSubmit = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        isNull(formData.id) ||
        isNull(formDetail.fixasset_id) ||
        isNull(formDetail.nama_asset) ||
        isNull(formDetail.code_asset)
      ) {
        defaultToastError("Harap lengkapi form terlebih dahulu !");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        if (isNull(formDetail.id)) {
          const defaultData = {
            id_service_header: formData.id,
            fixasset_id: formDetail.fixasset_id,
            is_garansi: formDetail.is_garansi,
            tanggal_akhir_garansi: formDetail.is_garansi
              ? moment(formDetail.tanggal_akhir_garansi)
                  .local()
                  .format("YYYY-MM-DD")
              : "",
            is_maintenance: formDetail.is_maintenance,
            tanggal_maintenance_selanjutnya: formDetail.is_maintenance
              ? moment(formDetail.tanggal_maintenance_selanjutnya)
                  .local()
                  .format("YYYY-MM-DD")
              : "",
            nama_asset: formDetail.nama_asset,
            code_asset: formDetail.code_asset,
            no_faktur: formDetail.no_faktur,
            deskripsi_kerusakan: formDetail.deskripsi_kerusakan,
            kelengkapan: formDetail.kelengkapan,
            status_barang: formDetail.status_barang,
            remark: formDetail.remark,
            detail_perbaikan: listDetailWork,
          };
          const api = await instance4.post(
            "/wmsAsset/maintance/add-detail",
            defaultData
          );
          const res = api.data;
          if (res.status === 200) {
            setFormDetail({ ...formDetail, id: res.id });
            defaultToastSuccess(res.message);
            await setNewDataReqList(formData.id);
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          } else {
            defaultToastError(res.message);
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          }
        } else {
          const defaultData = {
            id: formDetail.id,
            id_service_header: formData.id,
            fixasset_id: formDetail.fixasset_id,
            is_garansi: formDetail.is_garansi,
            tanggal_akhir_garansi: formDetail.is_garansi
              ? moment(formDetail.tanggal_akhir_garansi)
                  .local()
                  .format("YYYY-MM-DD")
              : "",
            is_maintenance: formDetail.is_maintenance,
            tanggal_maintenance_selanjutnya: formDetail.is_maintenance
              ? moment(formDetail.tanggal_maintenance_selanjutnya)
                  .local()
                  .format("YYYY-MM-DD")
              : "",
            nama_asset: formDetail.nama_asset,
            code_asset: formDetail.code_asset,
            no_faktur: formDetail.no_faktur,
            deskripsi_kerusakan: formDetail.deskripsi_kerusakan,
            kelengkapan: formDetail.kelengkapan,
            status_barang: formDetail.status_barang,
            remark: formDetail.remark,
            detail_perbaikan: listDetailWork,
          };
          const api = await instance4.post(
            "/wmsAsset/maintance/update-detail",
            defaultData
          );
          const res = api.data;
          if (res.status === 200) {
            defaultToastSuccess(res.message);
            await setNewDataReqList(formData.id);
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            setFormDetail(FORM_RESET_DETAIL);
            setListDetailWork([]);
          } else {
            defaultToastError(res.message);
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          }
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickSelectAsset = (row) => {
    if (!isNull(formData.id)) {
      setFormDetail({
        ...formDetail,
        fixasset_id: row?.id,
        nama_asset: row?.name,
        code_asset: row?.code,
      });
    }
    setShowModalFA(false);
  };

  const handleChange = (text) => (e) => {
    setFormDetail({
      ...formDetail,
      [text]: e.target.value,
    });
  };

  return (
    <>
      {showModalFA && (
        <ModalFixedAsset
          setShowModal={() => setShowModalFA(false)}
          handleClickSelectAsset={handleClickSelectAsset}
          onlySelect={false}
          formData={formData}
        />
      )}
      <form action=''>
        <Grid container spacing={2} alignItems='stretch' direction='row'>
          <Grid item sm={12}>
            <Paper
              className={classes.paper}
              style={{
                padding: "1rem 1.5rem",
                minHeight: "262px",
              }}>
              <Title subtitle={"FORM DETAIL MAINTENANCE"} />
              <Grid container spacing={1}>
                <Grid item sm={12}>
                  <InputTextMaster
                    name='id'
                    label='ID'
                    id='id'
                    placeholder=''
                    disabled={true}
                    value={formDetail.id}
                  />
                </Grid>
                <Grid item sm={12}>
                  {isNull(formDetail.fixasset_id) ? (
                    <InputTextMaster
                      name='id'
                      label=' ID FIXED ASSET'
                      id='id'
                      placeholder={"Cari Fixed Asset"}
                      disabled={true}
                      value={formDetail?.fixasset_id}
                      withButton={true}>
                      <button
                        type={"button"}
                        onClick={() => setShowModalFA(!showModalFA)}
                        style={{
                          borderRight: "1px solid #EAEAEA",
                          borderTop: "1px solid #EAEAEA",
                          borderBottom: "1px solid #EAEAEA",
                          borderLeft: "0",
                          background: "#fff",
                          padding: "0 0.8rem",
                          cursor: "pointer",
                          borderRadius: "0 6px 6px 0",
                        }}>
                        <SearchIcon width={"16"} height={"16"} fill={"#333"} />
                      </button>
                    </InputTextMaster>
                  ) : (
                    <InputTextMaster
                      name='id'
                      label=' ID FIXED ASSET'
                      id='id'
                      placeholder={"ID Fixed Asset"}
                      value={formDetail.fixasset_id}
                      disabled={true}
                      withButton={false}
                    />
                  )}
                </Grid>
                <Grid item sm={12}>
                  <InputTextMaster
                    name='code'
                    label='NAMA FIXED ASSET'
                    id='code'
                    value={formDetail.nama_asset}
                    readOnly={true}
                    disabled={true}
                    placeholder='Nama Fixed Asset'
                  />
                </Grid>
                <Grid item sm={12}>
                  <InputTextMaster
                    name='code'
                    label='KODE FIXED ASSET'
                    id='code'
                    value={formDetail.code_asset}
                    readOnly={true}
                    disabled={true}
                    placeholder='Code Fixed Asset'
                  />
                </Grid>
                <Grid item sm={12}>
                  <InputOptionMaster
                    name='status_barang'
                    label='STATUS BARANG'
                    id='status_barang'
                    // withSearch={true}
                    value={formDetail.status_barang}
                    // labelValue={formDetail.nama_status_barang}
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormDetail({
                          ...formDetail,
                          status_barang: "",
                        //   nama_status_barang: "Pilih Status Barang",
                        });
                      } else {
                        setFormDetail({
                          ...formDetail,
                          status_barang: e.target.value,
                        //   nama_status_barang: e.label,
                        });
                      }
                    }}
                    data={status_barang}
                  />
                </Grid>

                <Grid item sm={12}>
                  <InputTextArea
                    name='kelengkapan'
                    label='KELENGKAPAN'
                    id='kelengkapan'
                    placeholder='Kelengkapan'
                    value={formDetail.kelengkapan}
                    rows={3}
                    onChange={handleChange("kelengkapan")}
                  />
                </Grid>

                <Grid item sm={12}>
                  <InputReactDatepicker
                    selected={formDetail.tanggal_akhir_garansi}
                    label=''
                    dateFormat='dd/MM/yyyy'
                    handleChangeToday={(e) =>
                      setFormDetail({
                        ...formDetail,
                        tanggal_akhir_garansi: e,
                      })
                    }
                    onChange={(e) =>
                      setFormDetail({
                        ...formDetail,
                        tanggal_akhir_garansi: e,
                      })
                    }
                    disabled={formDetail.is_garansi ? false : true}
                  />
                  <div
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      marginTop: "-3.7rem",
                    }}>
                    <InputCheckboxMaster
                      checked={formDetail.is_garansi}
                      name='is_garansi'
                      id='is_garansi'
                      label='Dengan Garansi'
                      onChange={() =>
                        setFormDetail({
                          ...formDetail,
                          is_garansi: !formDetail.is_garansi,
                        })
                      }
                    />
                  </div>
                </Grid>

                <Grid item sm={12}>
                  <InputTextArea
                    name='deskripsi_kerusakan'
                    label='DESKRIPSI KERUSAKAN'
                    id='deskripsi_kerusakan'
                    placeholder='Deskripsi Kerusakan'
                    value={formDetail.deskripsi_kerusakan}
                    rows={3}
                    onChange={handleChange("deskripsi_kerusakan")}
                  />
                </Grid>

                <Grid item sm={12}>
                  <InputReactDatepicker
                    selected={formDetail.tanggal_maintenance_selanjutnya}
                    label=''
                    dateFormat='dd/MM/yyyy'
                    handleChangeToday={(e) =>
                      setFormDetail({
                        ...formDetail,
                        tanggal_maintenance_selanjutnya: e,
                      })
                    }
                    onChange={(e) =>
                      setFormDetail({
                        ...formDetail,
                        tanggal_maintenance_selanjutnya: e,
                      })
                    }
                    disabled={formDetail.is_maintenance ? false : true}
                  />
                  <div
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      marginTop: "-3.7rem",
                    }}>
                    <InputCheckboxMaster
                      checked={formDetail.is_maintenance}
                      name='is_maintenance'
                      id='is_maintenance'
                      label='Maintenance Selanjutnya'
                      onChange={() =>
                        setFormDetail({
                          ...formDetail,
                          is_maintenance: !formDetail.is_maintenance,
                        })
                      }
                    />
                  </div>
                </Grid>

                <Grid item sm={12}>
                  <Grid
                    container
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'>
                    <MasterButton
                      name={"RESET"}
                      outline={true}
                      color={"danger"}
                      type={"button"}
                      size={"md"}
                      onClick={() => {
                        setFormDetail(FORM_RESET_DETAIL);
                        setListDetailWork([]);
                      }}
                    />
                    <MasterButton
                      color={disabled.color}
                      name={disabled.label}
                      disabled={disabled.disabled}
                      outline={true}
                      onClick={handleClickSubmit}
                      type={"button"}
                      size={"md"}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
